import { RouterProvider } from "react-router-dom";
import { router } from "../lib/router";

export function Routing() {
  return <RouterProvider router={router} />;
}
